export const togglePasswordVisibility = () => {
    const passwordInputs = document.querySelectorAll('input.password');

    passwordInputs.forEach((input) => {
        if (input.getAttribute('data-enabled') !== 'true') {
            let inputParent = input.parentElement;
            let passwordToggleBtn = inputParent.querySelector('.password-reveal');

            passwordToggleBtn.addEventListener('click', (e: Event) => {
                e.preventDefault();
                const type = input.getAttribute('type') === 'password' ? 'text' : 'password';
                input.setAttribute('type', type);
                inputParent.querySelector('span').classList.toggle('icon-eye');
            });

            input.setAttribute('data-enabled', 'true');
        }
    });
}
